/**
 * Namespaced privileges owned by the ops-platform-v3 consuming app.
 *
 * Per docs/designs/20260413_UNIFIED_AUTH_PRIVILEGE_VOCABULARY.md §5, consuming apps
 * register their own namespaced privileges. ams-internal-auth stores role
 * privilege strings as opaque (validated only by regex format); enforcement
 * happens here at the ops-platform-v3 request boundary.
 *
 * Adding a new opsv3.* privilege requires a code change (same discipline as
 * the auth-service vocabulary) — there is no admin UI and no runtime registration.
 */
export const OPSV3_EXPOAMS_SCAN = 'opsv3.expoams.scan';
export const OPSV3_EXPOAMS_INVENTORY_READ = 'opsv3.expoams.inventory.read';
export const OPSV3_EXPOAMS_MANAGE_SHEETS = 'opsv3.expoams.manage_sheets';
export const OPSV3_EXPOAMS_PRIVILEGES = [
    OPSV3_EXPOAMS_SCAN,
    OPSV3_EXPOAMS_INVENTORY_READ,
    OPSV3_EXPOAMS_MANAGE_SHEETS,
];
export const OPSV3_STATION_DATA_DASHBOARD_TABLE_READ = 'opsv3.station_data_dashboard.table.read';
export const OPSV3_STATION_DATA_DASHBOARD_ANALYSIS_READ = 'opsv3.station_data_dashboard.analysis.read';
export const OPSV3_STATION_DATA_DASHBOARD_CHARTS_READ = 'opsv3.station_data_dashboard.charts.read';
export const OPSV3_STATION_DATA_DASHBOARD_EXPORT = 'opsv3.station_data_dashboard.export';
export const OPSV3_STATION_DATA_DASHBOARD_PRIVILEGES = [
    OPSV3_STATION_DATA_DASHBOARD_TABLE_READ,
    OPSV3_STATION_DATA_DASHBOARD_ANALYSIS_READ,
    OPSV3_STATION_DATA_DASHBOARD_CHARTS_READ,
    OPSV3_STATION_DATA_DASHBOARD_EXPORT,
];
export const OPSV3_DATA_VIS_METRIX_STATION_READ = 'opsv3.data_vis.metrix_station.read';
export const OPSV3_DATA_VIS_ECHEM_READ = 'opsv3.data_vis.echem.read';
export const OPSV3_DATA_VIS_PRIVILEGES = [
    OPSV3_DATA_VIS_METRIX_STATION_READ,
    OPSV3_DATA_VIS_ECHEM_READ,
];
export const OPSV3_STATION_DATA_DASHBOARD_TEST_FACILITIES_READ = 'opsv3.station_data_dashboard.test_facilities.read';
export const OPSV3_STATION_DATA_DASHBOARD_TEST_FACILITIES_MANAGE = 'opsv3.station_data_dashboard.test_facilities.manage';
export const OPSV3_STATION_DATA_DASHBOARD_PRODUCTION_FACILITIES_READ = 'opsv3.station_data_dashboard.production_facilities.read';
export const OPSV3_STATION_DATA_DASHBOARD_TEST_FACILITIES_PRIVILEGES = [
    OPSV3_STATION_DATA_DASHBOARD_TEST_FACILITIES_READ,
    OPSV3_STATION_DATA_DASHBOARD_TEST_FACILITIES_MANAGE,
];
// ----- BOM privileges (Plan materials-01) -----
export const OPSV3_BOM_ITEMS_READ = 'opsv3.bom.items.read';
export const OPSV3_BOM_ITEMS_EXPORT_SHEET = 'opsv3.bom.items.export_sheet';
export const OPSV3_BOM_ITEMS_WRITE = 'opsv3.bom.items.write';
export const OPSV3_BOM_ITEMS_BULK_IMPORT = 'opsv3.bom.items.bulk_import';
export const OPSV3_BOM_ITEMS_PROMOTE = 'opsv3.bom.items.promote';
export const OPSV3_BOM_ITEMS_RETIRE = 'opsv3.bom.items.retire';
// bom-02 supersession (docs/designs/20260501_BOM_SUPERSESSION_DESIGN.md §5):
// bulk parent-BOM rewrite — admin-tier only (bom_admin + superadmin) initially.
export const OPSV3_BOM_ITEMS_SUPERSEDE = 'opsv3.bom.items.supersede';
export const OPSV3_BOM_ARENA_SYNC_READ = 'opsv3.bom.arena_sync.read';
export const OPSV3_BOM_ARENA_SYNC_WRITE = 'opsv3.bom.arena_sync.write';
export const OPSV3_BOM_ARENA_SYNC_RUN = 'opsv3.bom.arena_sync.run';
export const OPSV3_BOM_ARENA_SYNC_REVIEW_ORPHANS = 'opsv3.bom.arena_sync.review_orphans';
export const OPSV3_BOM_ARENA_SYNC_REVIEW_CONFLICTS = 'opsv3.bom.arena_sync.review_conflicts';
export const OPSV3_BOM_ROLE_DEFAULT_FILTERS_WRITE = 'opsv3.bom.role_default_filters.write';
export const OPSV3_BOM_CATEGORIES_READ = 'opsv3.bom.categories.read';
export const OPSV3_BOM_CATEGORIES_WRITE = 'opsv3.bom.categories.write';
export const OPSV3_BOM_SUPPLIERS_READ = 'opsv3.bom.suppliers.read';
export const OPSV3_BOM_SUPPLIERS_WRITE = 'opsv3.bom.suppliers.write';
export const OPSV3_BOM_SUPPLIERS_QUALIFY = 'opsv3.bom.suppliers.qualify';
export const OPSV3_BOM_ALTERNATES_READ = 'opsv3.bom.alternates.read';
export const OPSV3_BOM_ALTERNATES_WRITE = 'opsv3.bom.alternates.write';
export const OPSV3_BOM_EXCEPTIONS_REVIEW = 'opsv3.bom.exceptions.review';
export const OPSV3_BOM_CAN_I_BUILD_RUN = 'opsv3.bom.can_i_build.run';
export const OPSV3_BOM_PRIVILEGES = [
    OPSV3_BOM_ITEMS_READ,
    OPSV3_BOM_ITEMS_WRITE,
    OPSV3_BOM_ITEMS_EXPORT_SHEET,
    OPSV3_BOM_ITEMS_BULK_IMPORT,
    OPSV3_BOM_ITEMS_PROMOTE,
    OPSV3_BOM_ITEMS_RETIRE,
    OPSV3_BOM_ITEMS_SUPERSEDE,
    OPSV3_BOM_ARENA_SYNC_READ,
    OPSV3_BOM_ARENA_SYNC_WRITE,
    OPSV3_BOM_ARENA_SYNC_RUN,
    OPSV3_BOM_ARENA_SYNC_REVIEW_ORPHANS,
    OPSV3_BOM_ARENA_SYNC_REVIEW_CONFLICTS,
    OPSV3_BOM_ROLE_DEFAULT_FILTERS_WRITE,
    OPSV3_BOM_CATEGORIES_READ,
    OPSV3_BOM_CATEGORIES_WRITE,
    OPSV3_BOM_SUPPLIERS_READ,
    OPSV3_BOM_SUPPLIERS_WRITE,
    OPSV3_BOM_SUPPLIERS_QUALIFY,
    OPSV3_BOM_ALTERNATES_READ,
    OPSV3_BOM_ALTERNATES_WRITE,
    OPSV3_BOM_EXCEPTIONS_REVIEW,
    OPSV3_BOM_CAN_I_BUILD_RUN,
];
// ----- Inventory privileges (Plan materials-01; consumed in materials-03) -----
export const OPSV3_INVENTORY_STOCK_READ = 'opsv3.inventory.stock.read';
export const OPSV3_INVENTORY_STOCK_CHECKIN = 'opsv3.inventory.stock.checkin';
export const OPSV3_INVENTORY_STOCK_CHECKOUT = 'opsv3.inventory.stock.checkout';
export const OPSV3_INVENTORY_STOCK_TRANSFER = 'opsv3.inventory.stock.transfer';
export const OPSV3_INVENTORY_STOCK_ADJUST = 'opsv3.inventory.stock.adjust';
export const OPSV3_INVENTORY_LOTS_READ = 'opsv3.inventory.lots.read';
export const OPSV3_INVENTORY_LOTS_WRITE = 'opsv3.inventory.lots.write';
export const OPSV3_INVENTORY_LOTS_SET_DISPOSITION = 'opsv3.inventory.lots.set_disposition';
export const OPSV3_INVENTORY_LOTS_RE_RELEASE = 'opsv3.inventory.lots.re_release';
export const OPSV3_INVENTORY_LOTS_ASSIGN_ACCESS_GROUPS = 'opsv3.inventory.lots.assign_access_groups';
export const OPSV3_INVENTORY_LOCATIONS_READ = 'opsv3.inventory.locations.read';
export const OPSV3_INVENTORY_LOCATIONS_WRITE = 'opsv3.inventory.locations.write';
export const OPSV3_INVENTORY_LOCATIONS_ASSIGN_ACCESS_GROUP = 'opsv3.inventory.locations.assign_access_group';
export const OPSV3_INVENTORY_RESERVATIONS_READ = 'opsv3.inventory.reservations.read';
export const OPSV3_INVENTORY_RESERVATIONS_WRITE = 'opsv3.inventory.reservations.write';
export const OPSV3_INVENTORY_RECEIVING_READ = 'opsv3.inventory.receiving.read';
export const OPSV3_INVENTORY_RECEIVING_WRITE = 'opsv3.inventory.receiving.write';
export const OPSV3_INVENTORY_RECEIVING_QC = 'opsv3.inventory.receiving.qc';
export const OPSV3_INVENTORY_PRODUCTION_RUNS_READ = 'opsv3.inventory.production_runs.read';
export const OPSV3_INVENTORY_PRODUCTION_RUNS_WRITE = 'opsv3.inventory.production_runs.write';
export const OPSV3_INVENTORY_SHEET_SYNC_READ = 'opsv3.inventory.sheet_sync.read';
export const OPSV3_INVENTORY_SHEET_SYNC_WRITE = 'opsv3.inventory.sheet_sync.write';
export const OPSV3_INVENTORY_SHEET_SYNC_RUN = 'opsv3.inventory.sheet_sync.run';
export const OPSV3_INVENTORY_SHEET_SYNC_REVIEW_ORPHANS = 'opsv3.inventory.sheet_sync.review_orphans';
export const OPSV3_INVENTORY_PRIVILEGES = [
    OPSV3_INVENTORY_STOCK_READ,
    OPSV3_INVENTORY_STOCK_CHECKIN,
    OPSV3_INVENTORY_STOCK_CHECKOUT,
    OPSV3_INVENTORY_STOCK_TRANSFER,
    OPSV3_INVENTORY_STOCK_ADJUST,
    OPSV3_INVENTORY_LOTS_READ,
    OPSV3_INVENTORY_LOTS_WRITE,
    OPSV3_INVENTORY_LOTS_SET_DISPOSITION,
    OPSV3_INVENTORY_LOTS_RE_RELEASE,
    OPSV3_INVENTORY_LOTS_ASSIGN_ACCESS_GROUPS,
    OPSV3_INVENTORY_LOCATIONS_READ,
    OPSV3_INVENTORY_LOCATIONS_WRITE,
    OPSV3_INVENTORY_LOCATIONS_ASSIGN_ACCESS_GROUP,
    OPSV3_INVENTORY_RESERVATIONS_READ,
    OPSV3_INVENTORY_RESERVATIONS_WRITE,
    OPSV3_INVENTORY_RECEIVING_READ,
    OPSV3_INVENTORY_RECEIVING_WRITE,
    OPSV3_INVENTORY_RECEIVING_QC,
    OPSV3_INVENTORY_PRODUCTION_RUNS_READ,
    OPSV3_INVENTORY_PRODUCTION_RUNS_WRITE,
    OPSV3_INVENTORY_SHEET_SYNC_READ,
    OPSV3_INVENTORY_SHEET_SYNC_WRITE,
    OPSV3_INVENTORY_SHEET_SYNC_RUN,
    OPSV3_INVENTORY_SHEET_SYNC_REVIEW_ORPHANS,
];
// ----- Email privileges (Plan email-01) -----
// Phase B atoms campaign.{create,send,cancel} + read were locked in
// docs/designs/20260419_EMAIL_MODULE_DESIGN.md; email-01 adds send,
// campaign.close, backfill.run per the migration roadmap
// (docs/designs/20260610_EMAIL_CONFERENCE_MIGRATION_PLAN.md §2) to cover the
// ported StationJo surface (compose/reply, §21 multi-batch close, backfill).
export const OPSV3_EMAIL_READ = 'opsv3.email.read';
export const OPSV3_EMAIL_SEND = 'opsv3.email.send';
export const OPSV3_EMAIL_CAMPAIGN_CREATE = 'opsv3.email.campaign.create';
export const OPSV3_EMAIL_CAMPAIGN_SEND = 'opsv3.email.campaign.send';
export const OPSV3_EMAIL_CAMPAIGN_CANCEL = 'opsv3.email.campaign.cancel';
export const OPSV3_EMAIL_CAMPAIGN_CLOSE = 'opsv3.email.campaign.close';
export const OPSV3_EMAIL_BACKFILL_RUN = 'opsv3.email.backfill.run';
export const OPSV3_EMAIL_PRIVILEGES = [
    OPSV3_EMAIL_READ,
    OPSV3_EMAIL_SEND,
    OPSV3_EMAIL_CAMPAIGN_CREATE,
    OPSV3_EMAIL_CAMPAIGN_SEND,
    OPSV3_EMAIL_CAMPAIGN_CANCEL,
    OPSV3_EMAIL_CAMPAIGN_CLOSE,
    OPSV3_EMAIL_BACKFILL_RUN,
];
// ----- Conference privileges (Plan email-01) -----
export const OPSV3_CONFERENCE_READ = 'opsv3.conference.read';
export const OPSV3_CONFERENCE_NOTES_WRITE = 'opsv3.conference.notes.write';
export const OPSV3_CONFERENCE_ATTENDEES_WRITE = 'opsv3.conference.attendees.write';
export const OPSV3_CONFERENCE_IMPORT_RUN = 'opsv3.conference.import.run';
export const OPSV3_CONFERENCE_ENRICH_RUN = 'opsv3.conference.enrich.run';
export const OPSV3_CONFERENCE_TEAM_MANAGE = 'opsv3.conference.team.manage';
export const OPSV3_CONFERENCE_PRIVILEGES = [
    OPSV3_CONFERENCE_READ,
    OPSV3_CONFERENCE_NOTES_WRITE,
    OPSV3_CONFERENCE_ATTENDEES_WRITE,
    OPSV3_CONFERENCE_IMPORT_RUN,
    OPSV3_CONFERENCE_ENRICH_RUN,
    OPSV3_CONFERENCE_TEAM_MANAGE,
];
// ----- Procurement privileges (Plan procurement-01) -----
// Quote → PO → Invoice procure-to-pay spine. Naming triple: URL /procurement,
// ModuleId procurement, privileges opsv3.procurement.<resource>.<action>
// (docs/designs/20260621_PROCUREMENT_PO_WORKFLOW_DESIGN.md §7).
export const OPSV3_PROCUREMENT_QUOTES_READ = 'opsv3.procurement.quotes.read';
export const OPSV3_PROCUREMENT_QUOTES_WRITE = 'opsv3.procurement.quotes.write';
export const OPSV3_PROCUREMENT_PURCHASE_ORDERS_READ = 'opsv3.procurement.purchase_orders.read';
export const OPSV3_PROCUREMENT_PURCHASE_ORDERS_WRITE = 'opsv3.procurement.purchase_orders.write';
export const OPSV3_PROCUREMENT_PURCHASE_ORDERS_ISSUE = 'opsv3.procurement.purchase_orders.issue';
export const OPSV3_PROCUREMENT_INVOICES_READ = 'opsv3.procurement.invoices.read';
export const OPSV3_PROCUREMENT_INVOICES_WRITE = 'opsv3.procurement.invoices.write';
export const OPSV3_PROCUREMENT_INVOICES_MATCH = 'opsv3.procurement.invoices.match';
export const OPSV3_PROCUREMENT_INVOICES_APPROVE = 'opsv3.procurement.invoices.approve';
export const OPSV3_PROCUREMENT_DOCUMENTS_UPLOAD = 'opsv3.procurement.documents.upload';
export const OPSV3_PROCUREMENT_DOCUMENTS_PARSE = 'opsv3.procurement.documents.parse';
// Plan procurement-06 — Hochuen work-order sheet sync (design §8.1).
export const OPSV3_PROCUREMENT_WORK_ORDERS_READ = 'opsv3.procurement.work_orders.read';
export const OPSV3_PROCUREMENT_WORK_ORDERS_SYNC = 'opsv3.procurement.work_orders.sync';
export const OPSV3_PROCUREMENT_PRIVILEGES = [
    OPSV3_PROCUREMENT_QUOTES_READ,
    OPSV3_PROCUREMENT_QUOTES_WRITE,
    OPSV3_PROCUREMENT_PURCHASE_ORDERS_READ,
    OPSV3_PROCUREMENT_PURCHASE_ORDERS_WRITE,
    OPSV3_PROCUREMENT_PURCHASE_ORDERS_ISSUE,
    OPSV3_PROCUREMENT_INVOICES_READ,
    OPSV3_PROCUREMENT_INVOICES_WRITE,
    OPSV3_PROCUREMENT_INVOICES_MATCH,
    OPSV3_PROCUREMENT_INVOICES_APPROVE,
    OPSV3_PROCUREMENT_DOCUMENTS_UPLOAD,
    OPSV3_PROCUREMENT_DOCUMENTS_PARSE,
    OPSV3_PROCUREMENT_WORK_ORDERS_READ,
    OPSV3_PROCUREMENT_WORK_ORDERS_SYNC,
];
// ----- Commercial Console privileges -----
export const OPSV3_COMMERCIAL_CONSOLE_READ = 'opsv3.commercial_console.read';
export const OPSV3_COMMERCIAL_CONSOLE_WRITE = 'opsv3.commercial_console.write';
export const OPSV3_COMMERCIAL_CONSOLE_PRIVILEGES = [
    OPSV3_COMMERCIAL_CONSOLE_READ,
    OPSV3_COMMERCIAL_CONSOLE_WRITE,
];
//# sourceMappingURL=privileges-opsv3.js.map